import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ModalRef } from '@freelancer/ui';

@Component({
  template: `
    <app-award-modal-body class="ModalBody"
      [bidId]="bidId"
    ></app-award-modal-body>
    <app-award-modal-sidebar class="ModalSidebar">
    </app-award-modal-sidebar>
  `,
  styleUrls: ['./award-modal.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AwardModalComponent {
  @Input() bidId: number;

  constructor(private modalRef: ModalRef<AwardModalComponent>) {}

  close() {
    this.modalRef.close();
  }
}



// WEBPACK FOOTER //
// ./src/app/projects/award-modal/award-modal.component.ts